import emergencyContact from '@/helpers/emergencyContact'

const state = {
  contact_1: new emergencyContact(),
  contact_2: new emergencyContact(),
  contact_3: new emergencyContact(),
  physician: {
    name: '',
    phone: ''
  },
  hospital_preference: ''
}

const mutations = {
  setName(state, payload) {
    state['contact_' + payload.num].name = payload.value
  },
  setRelationship(state, payload) {
    state['contact_' + payload.num].relationship = payload.value
  },
  setPhone(state, payload) {
    state['contact_' + payload.num].phone = payload.value
  },
  setPhoneType(state, payload) {
    state['contact_' + payload.num].phone_type = payload.value
  },
  setAltPhone(state, payload) {
    state['contact_' + payload.num].alt_phone = payload.value
  },
  setAltPhoneType(state, payload) {
    state['contact_' + payload.num].alt_phone_type = payload.value
  },
  setPhysicianName(state, value) {
    state.physician.name = value
  },
  setPhysicianPhone(state, value) {
    state.physician.phone = value
  },
  setHospitalPreference(state, value) {
    state.hospital_preference = value
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
